import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { MsisdnTextCSSStyleImpl } from './msisdntextcss';

export class SpecialCallerCSSStyleImpl extends MsisdnTextCSSStyleImpl
{
    getCountryCodeCSSStyle(): object {
        return {
         fontSize: this.getResources().getFont(Fonts.h9),
         color: "#959595",
         height: "40px",
         position: "absolute",
         textDecoration: "none",
         border: 0,
         marginTop: "10px",
         fontWeight: 500,
         letterSpacing: 0,
         lineHeight: "40px",
         outline: "none",
         paddingLeft: "10px", 
         marginRight: "5px",
        };
     }

    
    getTextCSSStyle(isFloatingLabel: boolean, isDisabled:boolean): object 
    {
       
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                backgroundColor:isDisabled? this.getResources().getColor(Colors.color_17):this.getResources().getColor(Colors.color_5),
                color: this.getResources().getColor(Colors.color_4),
                height: "60px",
                // bottom: "3px",
                boxSizing: "border-box",
                textDecoration: "none",
                fontWeight: 500,
                letterSpacing: 0,
                width:"100%",
                lineHeight: "40px",
                borderRadius:'35px',
                border:'1px solid'+this.getResources().getColor(Colors.color_8),
                outline: "none",
                marginLeft:'5px',
            };
    }
    getErrorCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h9),
            color: this.getResources().getColor(Colors.color_4),
            height: "60px",
            // bottom: "3px",
            textDecoration: "none",
            fontWeight: 500,
            letterSpacing: 0,
            marginLeft:'0px',
            lineHeight: "40px",
            border:'1px solid '+this.getResources().getColor(Colors.color_8),
            outline: "none",
            borderRadius:'35px',
            backgroundColor: this.getResources().getColor(Colors.color_5),
            boxSizing: "border-box",
            // borderLeft: "2px solid " + this.getResources().getColor(Colors.color_12),
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/msisdntext/specialcallercss.tsx